import localStore from 'store';
import { message } from 'antd'
import qs from 'qs';
import JSEncrypt from 'jsencrypt'
import _ from "lodash";

export function uploadHeadersGet () {
  const userinfo = localStore.get('userInfo');
  const employeeInfo = localStore.get('employeeInfo');
  const roleListStr = localStore.get('roleListStr') || '';
  return {
    'Authorization': `${_.get(userinfo, 'token_type', 'bearer')} ${localStore.get('token')}`,
    'x-appid-header': '7',
    'x-userid-header': _.get(employeeInfo, 'userId', ''),
    'x-employee-no-header': _.get(employeeInfo, 'employeeNo', ''),
    'x-username-header': encodeURIComponent(_.get(employeeInfo, 'employeeName', '')),
    'x-orgLlOneCode-header': encodeURIComponent(_.get(employeeInfo, 'orgLlOneCode', '')),
    'x-orgLlTwoCode-header': encodeURIComponent(_.get(employeeInfo, 'orgLlTwoCode', '')),
    'x-orgLlThirdCode-header': encodeURIComponent(_.get(employeeInfo, 'orgLlThirdCode', '')),
    'x-orgCode-header': encodeURIComponent(_.get(employeeInfo, 'orgCode', '')),
    'x-roles-header': encodeURIComponent(roleListStr),
  }
}

export function beforeUpload (e) {
  if (e.type.includes('video') || e.type.includes('audio')) {
    const isLt500M = e.size / 1024 / 1024  <= 500
    if (!isLt500M) {
      message.error('音视频最大不能超过500M！')
    }
    return isLt500M
  } else if (e.type.includes('image')) {
    const isLt5M = e.size / 1024 / 1024 <= 5
    if (!isLt5M) {
      message.error('图片最大不能超过5M！')
    }
    return isLt5M
  } else if (e.type.includes('vnd') || e.type.includes('text') || e.type.includes('pdf')) {
    const isLt5M = e.size / 1024 / 1024 <= 200
    if (!isLt5M) {
      message.error('文档最大不能超过200M！')
    }
    return isLt5M
  } else {
    return true
  }
}

export const loadScript = (callback: any) => {
  const s = document.createElement('script');
  s.setAttribute('src', 'https://rescdn.qqmail.com/node/ww/wwopenmng/js/sso/wwLogin-1.0.0.js');
  document.head.appendChild(s);
  s.onload = function () {
    callback();
  };
}

export function download(type, path, name) {
  let url = ''
  if (type == 'blob') {// 二进制文件下载
    url = window.URL.createObjectURL(new Blob([path], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel" }))
  } else if (type == 'qrcode') {// 二维码下载
    const canvasImg: any = document.getElementById(path);
    url = canvasImg.toDataURL('image/png');
  } else if (type == 'url') {// 直接下载url
    url = path
  }
  const link = document.createElement('a')
  link.style.display = "none"
  link.href = url
  link.setAttribute('download',name)
  document.body.appendChild(link)
  link.click()
  link.remove()
}

export const rsaEncodeByPublicKey = (originalText, publicKey) => {
  const jsencrypt = new JSEncrypt();
  jsencrypt.setPublicKey(publicKey);
  return jsencrypt.encrypt(originalText);
};
